<div class="header-logo" style="display: inline-block;">
  <a [routerLink]="['/']" style="display: inline-block;">
    <img alt="Logo" [attr.src]="headerLogo"
      style="width: 60px; height: 60px; margin-top: -30px !important;" />
  </a>
  <div style="margin-left: 20px !important; margin-top: 7px !important; display: inline-block;">
    <h1 style="color: #96b4ff !important; margin-bottom: -0.5px !important;">
      {{appTitle}}
    </h1>

    <span style="color: #b4cdff !important; font-weight: 900 !important; margin-left: 1px !important;">
      {{appVersion}}
    </span>
  </div>
</div>

<!--begin::Toolbar-->
<div class="d-flex align-items-center">
  <ng-container *ngIf="asideSelfDisplay">
    <!--begin::Aside Mobile Toggle-->
    <button class="btn p-0 burger-icon burger-icon-left" id="kt_aside_mobile_toggle">
      <span></span>
    </button>
    <!--end::Aside Mobile Toggle-->
	</ng-container>
	<!--begin::Topbar Mobile Toggle-->
	<button class="btn btn-hover-text-primary p-0 ml-2" id="kt_header_mobile_topbar_toggle">
		<span [inlineSVG]="'./assets/media/svg/icons/General/Other1.svg'" cacheSVG="true" class="svg-icon svg-icon-xl"></span>
	</button>
	<!--end::Topbar Mobile Toggle-->
</div>
<!--end::Toolbar-->
